export default "__VITE_ASSET__DxIPURwd__"